import { Route, Routes } from "react-router-dom";

import ChangePassword from "./components/ChangePassword";
import CreateAccount from "./components/CreateAccount";
import { EditPhasePlan } from "./components/EditPhasePlan";
import { EditPhasePlans } from "./components/EditPhasePlans";
import Login from "./components/Login";
import ProtectedRoutes from "./components/ProtectedRoutes";
import ShowSkedesplan from "./components/ShowSkedesplaner";
import Skedesplan from "./components/Skedesplan";
import Users from "./components/Users";
import Demo from "./components/Demo";

export default function MainRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ProtectedRoutes />}>
        {/* Error page ska läggas till */}
        <Route path="/skedesplan" element={<Skedesplan />} />
        <Route path="skedesplaner" element={<ShowSkedesplan />} />
        <Route path="create-account" element={<CreateAccount />} />
        <Route path="users" element={<Users />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="edit-phase-plans" element={<EditPhasePlans />} />
        <Route path="edit-phase-plan" element={<EditPhasePlan />} />
        <Route path="*" element={<Login />} />
      </Route>
      <Route path="demo" element={<Demo />} />
      <Route path="login" element={<Login />} />
    </Routes>
  );
}
